<template>
    <el-row class="container">
        <!--头部内容-->
        <el-col :span="24" class="header">
            <el-col :span="10" class="logo" :class="!isCollapse ?'logo-collapse-width':'logo-width'" v-text="title">
                <div class="api-branch" v-show="!isProduct && apiBranch.length > 0" v-text="apiBranch"></div>
            </el-col>
            <el-col :span="4">
                <div class="tools" @click.prevent="collapse">
                    <i class="fa fa-align-justify"></i>
                </div>
            </el-col>
            <el-col :span="10" class="userinfo">
                <span>产品&nbsp;:</span>
                <div class="product-select">
                  <el-select v-model.trim="appId" placeholder="请选择App">
                    <el-option
                      v-for="item in appList"
                      :key="item.app_id"
                      :label="item.desc"
                      :value="item.app_id">
                    </el-option>
                  </el-select>
                </div>
                <div class="user-info" v-show="info.name">
                    <span class="nickname">{{ info.name }}</span>
                    <span class="logout" @click="logout()">退出</span>
                </div>
            </el-col>
        </el-col>
        <!-- 菜单区域 -->
        <el-col :span="24" class="main">
            <div class="menu-box" :class="isCollapse ? 'auto-width':''">
                <el-menu :default-active="$route.path"
                         class="el-menu-vertical-demo"
                         @open="handleOpen"
                         @close="handleClose"
                         router
                         :collapse="!isCollapse">
                    <template v-for="(item, index) in menu"
                              v-if="!item.meta.hidden">
                        <el-submenu v-if="item.children " :index="item.path" :key="index">
                            <template slot="title">
                                <i :class="item.meta.icon"></i>
                                <span slot="title">{{ item.meta.label }}</span>
                            </template>
                            <el-menu-item
                                    v-for="child in item.children"
                                    :index="item.path + '/' + child.path"
                                    :key="child.path"
                                    v-if="!child.meta.hidden">
                                {{ child.meta.label }}
                            </el-menu-item>
                        </el-submenu>
                        <el-menu-item v-else :index="item.path" disabled :key="index">
                            <i :class="item.meta.icon"></i>
                            <span slot="title">{{ item.meta.label }}</span>
                        </el-menu-item>
                    </template>
                </el-menu>
            </div>
            <!--主内容-->
            <section class="content-container">
                <div class="grid-content bg-purple-light">
                    <el-col :span="24" class="breadcrumb-container">
                        <strong class="title">{{ $route.meta.label }}</strong>
                        <el-breadcrumb separator="/" class="breadcrumb-inner">
                            <el-breadcrumb-item v-for="item in $route.matched" :key="item.path">
                                {{ item.meta.label }}
                            </el-breadcrumb-item>
                        </el-breadcrumb>
                    </el-col>
                    <el-col :span="24" class="content-wrapper">
                        <transition name="fade" mode="out-in">
                            <router-view></router-view>
                        </transition>
                    </el-col>
                </div>
            </section>
        </el-col>
    </el-row>
</template>

<script>
import QuRequest from '../core/QuRequest';
import routerMap from '../router/index';
// import util from '../common/js/util';
import ewxLoginSDK from '@qtt/ewx-login-sdk';

const quRequest = new QuRequest();

export default {
    data () {
        return {
            appList: [],
            appId: 'qtt',
            isCollapse: true,
            info: {},
            title: quRequest.getProjectTitle(),
            // menu: util.checkPermApi(routerMap.routes),
            menu: routerMap.routes,
            disabled: true,
            isProduct: quRequest.isProduct(),
            branchMap: quRequest.getBranch(),
            apiBranch: '',
            token: ewxLoginSDK.getToken({ isPerm: true })
        };
    },
    methods: {
        getUserRoleList () {
            quRequest
                .send(quRequest.Apis.qukan.api.loginNew, {
                    token: ewxLoginSDK.getToken({ isPerm: true })
                })
                .then(
                    res => {
                        if (res.code === 0) {
                            //  "viewer" - 可读-阅览者
                            // "editor" - 可读可写-开发者
                            // "admin" - 可读可写-管理员
                            this.$store.commit('m:user/role', res.data.role);
                            // localStorage.setItem('role', res.data.role);
                            // 获取app列表
                            this.getAppList();
                        } else {
                            this.$message({
                                type: 'error',
                                message: res.msg
                            });
                        }
                    },
                    rej => {
                        this.$message({
                            type: 'error',
                            message: rej.msg
                        });
                    }
                );
        },
        getAppList () {
            quRequest.send(quRequest.Apis.qukan.api.getAppList, null).then(
                res => {
                    this.appList = res.data;
                    // window.localStorage.setItem('app_id', this.appId);
                    this.$store.commit('m:app/appId', this.appId);
                    this.$store.commit('m:app/appList', this.appList);
                    if (this.$route.path === '/app/topic-list') {
                        this.$router.push({ path: this.$route.path, query: { app_id: this.appId } });
                    }
                },
                rej => {
                    this.$message({
                        type: 'error',
                        message: rej.msg
                    });
                }
            );
        },
        // getAppName (id) {
        //     for (let item of this.appList) {
        //         if (item.app_id === id) {
        //             window.sessionStorage.setItem('app_info', JSON.stringify(item));
        //             break;
        //         }
        //     }
        // },
        async getMemberInfo () {
            try {
                this.info = (await ewxLoginSDK.getUserInfo({ isPerm: true })) || {};
            } catch (err) {
                this.$message.error(`${err.message || '未知错误'}`);
            }
            this.loading = false;
        },
        handleOpen () {},
        handleClose () {},
        // 退出登录
        logout () {
            this.$confirm('确认退出吗?', '提示', {}).then(() => {
                localStorage.clear();
                ewxLoginSDK.logout({ isPerm: true }).then(res => {
                    this.$router.push('/login');
                });
            });
        },
        // 折叠导航栏
        collapse () {
            this.isCollapse = !this.isCollapse;
        }
    },
    watch: {
        appId (val) {
            // window.localStorage.setItem('app_id', this.appId);
            this.$store.commit('m:app/appId', this.appId);
            this.$router.push({ path: this.$route.path, query: { app_id: this.appId } });
        }
    },
    mounted () {
        // if (this.branchMap && this.branchMap.qukan) {
        //     this.apiBranch = this.branchMap.qukan;
        // }
        // 获取鉴权用户信息
        this.getMemberInfo();
        // 获取用户角色列表
        this.getUserRoleList();
    }
};
</script>

<style lang="less">
.nprogress-container {
    position: fixed !important;
    width: 100%;
    height: 50px;
    z-index: 2048;
    pointer-events: none;
    display: inherit;

    #nprogress {
        @color: #004c32;

        .bar {
            background: @color;
        }
        .peg {
            box-shadow: 0 0 10px @color, 0 0 5px @color;
        }

        .spinner-icon {
            border-top-color: @color;
            border-left-color: @color;
        }
    }
}

.container {
    position: absolute;
    top: 0px;
    bottom: 0px;
    width: 100%;
    max-width: 100%;
    .auto-width {
        width: 230px;
    }
    .menu-box {
        background: #eef1f6;
    }

    .fa-user-o {
        margin: 0px 5px;
    }

    .header {
        height: 60px;
        line-height: 60px;
        background: #37b560;
        color: #fff;
        position: relative;

        .api-branch {
            position: absolute;
            top: 0;
            right: 0;
            height: 18px;
            line-height: 18px;
            padding: 0 8px;
            text-align: center;
            background-color: red;
            font-size: 14px;
            color: #ffffff;
        }

        .userinfo {
            text-align: right;
            float: right;
            .select-language {
                width: 120px;
            }
            .product-select {
                display: inline-block;
                margin-right: 25px;
            }
            .user-info {
                display: inline-block;
                span {
                    display: inline-block;
                    &.nickname {
                        margin-right: 15px;
                        font-size: 18px;
                    }
                    &.logout {
                        width: 60px;
                        height: 59px;
                        line-height: 59px;
                        font-size: 16px;
                        font-weight: bold;
                        text-align: center;
                        border-radius: 4px;
                        background: #37b560;
                        cursor: pointer;
                    }
                }
            }
            .userinfo-inner {
                cursor: pointer;
                color: #fff;
                img {
                    width: 40px;
                    height: 40px;
                    border-radius: 20px;
                    margin: 10px 0px 10px 10px;
                    float: right;
                }
            }
            .el-select {
                vertical-align: top;
                margin-left: 20px;
            }
        }
        .logo {
            //width:230px;
            height: 60px;
            font-size: 22px;
            padding-left: 20px;
            padding-right: 20px;
            border-color: rgba(238, 241, 146, 0.3);
            border-right-width: 1px;
            border-right-style: solid;
            position: relative;

            img {
                width: 40px;
                float: left;
                margin: 10px 10px 10px 18px;
            }
            .txt {
                color: #fff;
            }
        }
        .logo-width {
            width: 230px;
        }
        .logo-collapse-width {
            width: 65px;
        }
        .tools {
            padding: 0px 23px;
            width: 14px;
            height: 60px;
            line-height: 60px;
            cursor: pointer;
            i.fa-align-justify {
                line-height: 60px;
            }
        }
    }
    .main {
        display: flex;
        // background: #324057;
        position: absolute;
        top: 60px;
        bottom: 0px;
        overflow: hidden;
        aside {
            flex: 0 0 230px;
            width: 230px;
            // position: absolute;
            // top: 0px;
            // bottom: 0px;
            .el-menu {
                height: 100%;
                overflow-y: auto;
            }
            .collapsed {
                width: 60px;
                .item {
                    position: relative;
                }
                .submenu {
                    position: absolute;
                    top: 0px;
                    left: 60px;
                    z-index: 99999;
                    height: auto;
                    display: none;
                }
            }
        }
        .menu-collapsed {
            flex: 0 0 60px;
            width: 60px;
            .el-menu {
                width: 100% !important;
            }
        }
        .menu-expanded {
            flex: 0 0 230px;
            width: 230px;
            .el-menu {
                width: 100% !important;
            }
        }
        .content-container {
            flex: 1;
            overflow-y: auto;
            padding: 20px;
            .breadcrumb-container {
                .title {
                    width: 200px;
                    float: left;
                    font-size: 1rem;
                    font-weight: normal;
                }
                .breadcrumb-inner {
                    float: right;
                }
            }
            .content-wrapper {
                background-color: #fff;
                box-sizing: border-box;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// Home.vue?14984a4c